import { RouterProvider } from 'react-router';
import { QueryClientProvider, type QueryClient } from '@tanstack/react-query';
import { ApiProvider } from '@/api/apiContext';
import { AuthContextProvider, SessionProvider } from '@/auth';
import { AppBackdrop } from '@/shell/AppBackdrop';
import { router } from '@/routes/router';

/**
 * Provider order is load-bearing:
 *   QueryClient  -> the session query needs a cache
 *   Auth         -> the API client needs a token source
 *   Api          -> the session query needs a client
 *   Session      -> guards need the resolved session
 *   Router       -> guards run inside routes
 */
export function App({ queryClient }: { queryClient: QueryClient }) {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthContextProvider>
        <ApiProvider>
          <SessionProvider>
            <AppBackdrop>
              <RouterProvider router={router} />
            </AppBackdrop>
          </SessionProvider>
        </ApiProvider>
      </AuthContextProvider>
    </QueryClientProvider>
  );
}
